import { render, staticRenderFns } from "./IconPlayDisabled.vue?vue&type=template&id=5b58abc4&"
import script from "./IconPlayDisabled.vue?vue&type=script&lang=ts&"
export * from "./IconPlayDisabled.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports